import { useEffect, useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { TaskRow } from './TaskRow';
import { TaskEditor } from './TaskEditor';
import { empty, pick } from '@shared/copy';

export function SearchView() {
  const [q, setQ] = useState('');
  const ref = useRef<HTMLInputElement>(null);
  const [editingId, setEditingId] = useState<string | null>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  const r = useQuery({
    queryKey: ['search', q],
    queryFn: () => api.search(q),
    enabled: q.trim().length > 0,
  });

  const results = r.data ?? [];
  return (
    <div className="mx-auto max-w-3xl px-3 md:px-6 py-4 md:py-8">
      <input
        ref={ref}
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search tasks…"
        className="w-full bg-zinc-900 border border-zinc-800 rounded-xl px-4 py-3 text-base outline-none focus:border-amber-500"
      />
      <p className="text-xs text-zinc-500 mt-2">Try fragments. The whole word is rarely necessary.</p>

      <div className="mt-4">
        {q.trim() && results.length === 0 && !r.isLoading && (
          <div className="text-center text-zinc-500 py-12">{pick(empty.search)}</div>
        )}
        {results.length > 0 && (
          <ul className="divide-y divide-zinc-800/70 rounded-xl border border-zinc-800 bg-zinc-900/40 overflow-hidden">
            {results.map((t) => (
              <TaskRow key={t.id} task={t as any} onOpen={() => setEditingId(t.id)} />
            ))}
          </ul>
        )}
      </div>

      {editingId && <TaskEditor taskId={editingId} onClose={() => setEditingId(null)} />}
    </div>
  );
}
